import { render, staticRenderFns } from "./BaseBreadcrumbs.vue?vue&type=template&id=06d54730&functional=true&"
import script from "./BaseBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./BaseBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports